module.exports = __webpack_public_path__ + "static/media/PATS_6-634w.bd2426fe.png";